import * as API from '@/API'

const createState = () => ({
  isLoading: false,
  v2Locations: null,
  locations: null,
  dailyPulse: {},
  ecosystem: null,
  portSummary: {},
  reports: [],
  endpointStats: {},
  products: [],
  ports: [],
})

const actions = {
  async getLocations({ commit, state }) {
    if (state.locations !== null) return
    commit('setLoadingStatus', true)
    try {
      const results = await API.getLocations()
      commit('setNodeValue', { key: 'locations', value: results })
    } finally {
      commit('setLoadingStatus', false)
    }
  },
  getProducts: async ({ commit }) => {
    commit('setLoadingStatus', true)
    try {
      const results = await API.getProducts()
      commit('setNodeValue', { key: 'products', value: results })
      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    } finally {
      commit('setLoadingStatus', false)
    }
  },
  getPortSummary: async ({ commit }) => {
    try {
      const results = await API.getPortSummary()
      commit('setNodeValue', { key: 'portSummary', value: results })
      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getPorts: async ({ commit }, locationId) => {
    commit('setLoadingStatus', true)
    try {
      const results = await API.getPortsByLocation(locationId)
      commit('setNodeValue', { key: 'ports', value: results })
      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    } finally {
      commit('setLoadingStatus', false)
    }
  },
}

const getters = {
  productDiversityMap: state => {
    return state.products.reduce((map, product) => {
      let locationId = product.location_id
      let productKey = product.service_type === 'MEGAPORT' ? `${product.speed}` : product.service_type

      // New object if it doesn't exist
      if (!Object.prototype.hasOwnProperty.call(map, locationId)) {
        map[locationId] = {
          1000: null,
          10000: null,
          100000: null,
          400000: null,
          VRouter: null,
          MVE: null,
          IX: null,
        }
      }

      // Populate
      map[locationId] = {
        ...map[locationId],
        [productKey]: product.diversity,
      }

      return map
    }, {})
  },
  locationsArray: state => {
    return state.locations ? Object.values(state.locations) : []
  },
  locationsArrayProducts: (state, gettersProp) => {
    if (!state.locations) return []
    return Object.values(state.locations).map(location => {
      const diversity = gettersProp.productDiversityMap[location.id] || {}

      const map = {
        1000: {
          available: typeof diversity['1000'] === 'boolean' || false,
          diverse: diversity['1000'],
        },
        10000: {
          available: typeof diversity['10000'] === 'boolean' || false,
          diverse: diversity['10000'],
        },
        100000: {
          available: typeof diversity['100000'] === 'boolean' || false,
          diverse: diversity['100000'],
        },
        400000: {
          available: typeof diversity['400000'] === 'boolean' || false,
          diverse: diversity['400000'],
        },
        VRouter: {
          available: typeof diversity['VRouter'] === 'boolean' || false,
          diverse: diversity['VRouter'],
        },
        MVE: {
          available: typeof diversity['MVE'] === 'boolean' || false,
          diverse: diversity['MVE'],
        },
      }

      return {
        ...location,
        product: map,
      }
    })
  },
}

const mutations = {
  setLoadingStatus: (state, value) => {
    state.isLoading = value
  },
  setNodeValue: (state, nodeObject) => {
    state[nodeObject.key] = nodeObject.value
  },
}

export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state: createState(),
}
